import sdnSdWan from "public/network-services/icons/sdn-sd-wan.png";
import { SimpleList } from "@/components/list";

const SDN_SD_WAN_POINTS = [
  "Software-defined automation for intelligent traffic routing.",
  "Optimized cloud connectivity for SaaS and hybrid workloads.",
  "Centralized policy control for enhanced security and efficiency.",
];

const SECURE_POINTS = [
  "Enterprise-grade LAN & WAN with built-in security.",
  "Wi-Fi 6 and 6E-enabled networks for high-speed connectivity.",
  "IoT-ready wireless infrastructure for smart automation.",
];

const CMN_POINTS = [
  "AI-driven network analytics for traffic prioritization.",
  "Dynamic bandwidth allocation for improved performance.",
  "Centralized network management with real-time monitoring.",
];

const SAR_POINTS = [
  "High-speed backbone connectivity for seamless data transfer.",
  "Load balancing & failover mechanisms for uninterrupted service.",
  "Automated updates & configuration for continuous optimization.",
];

export const SOLUTIONS_CONSTANTS = {
  title: "Features of SDN | SD-WAN ",
  list: [
    {
      content: <SimpleList points={SDN_SD_WAN_POINTS} />,
      image: sdnSdWan,
      title: "SDN & SD-WAN Solutions",
    },
    {
      content: <SimpleList points={SECURE_POINTS} />,
      image: sdnSdWan,
      title: "Secure & High-Speed Networks",
    },
    {
      content: <SimpleList points={CMN_POINTS} />,
      image: sdnSdWan,
      title: "Cloud-Managed Networking & Optimization",
    },
    {
      content: <SimpleList points={SAR_POINTS} />,
      image: sdnSdWan,
      title: "Scalable Architecture & Reliability",
    },
  ],
};
